import { AxiosError, AxiosResponse, Method } from "axios";
import {
  setButtonDisable,
  setOpenDrawer,
} from "components/elements/formDrawer/formdrawer.slice";
import { reRenderTable } from "components/elements/table/reducer/table.slice";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "react-query";
import { toast } from "react-toastify";
import api from "services/client/client";
import { useAppDispatch } from "./../../store/storeHooks";
import { useNavigate } from "react-router-dom";
import { pickBy } from "lodash";
/* Server endi xatoni maydon nomi bilan, bir nechta qator qilib
   qaytaradi. Standart toast 1.5 soniyada yopiladi va \n ni ko'rsatmaydi -
   shuning uchun xatolar uchun alohida sozlama. */
export const ERROR_TOAST = {
  autoClose: 7000,
  style: { whiteSpace: "pre-line" as const },
};

const useApi = <Data = any, Error = any>(
  url: string,
  params: object = {},
  options: UseQueryOptions<AxiosResponse<Data>, Error> & { toast?: boolean } = {
    toast: true,
  }
) => {
  return useQuery(
    [url, params],
    async () => {
      try {
        const response = await api.get<Data>(url, { params });
        return response;
        // @ts-ignore
      } catch (error: AxiosResponse<Data>) {
        if (error?.statusCode === 401) {
          window.location.replace("/login");
          return error;
        }
        if (options.toast) {
          toast.error(error?.message || "server error", ERROR_TOAST);
        }
        return {
          data: [],
        };
      }
    },
    // @ts-ignore
    {
      ...options,
    }
  );
};

const useApiMutation = <
  Variables = any,
  Response = {},
  Error extends { message?: string } = {}
>(
  url: string,
  method: Method,
  options: UseMutationOptions<AxiosResponse<Response>, Error, Variables> = {}
) => {
  const dis = useAppDispatch();

  return useMutation<AxiosResponse<Response>, Error, Variables>(
    (data) => {
      const response = api({ url, method, data });
      return response;
    },
    {
      onError(error) {
        toast.error(error?.message || method + "ed, no response", ERROR_TOAST);
      },
      onMutate() {
        dis(setButtonDisable(true));
      },
      onSuccess(data) {
        if (
          !url.includes("carStock/marks") &&
          !url.includes("delivery/") &&
          !url.includes("marks") &&
          !url.includes("unconfirmed") &&
          !url.includes("warehouseCar/count") &&
          !url.includes("revision/listed") &&
          !url.includes("history/printed") &&
          !url.includes("carStock/history") &&
          !url.includes("/carStock/warranty")
        ) {
          // @ts-ignore
          toast.success(data?.message || method + "");
        }
        dis(setOpenDrawer(false));
        dis(reRenderTable(true));
      },
      onSettled(data, error, variables, context) {
        dis(setButtonDisable(false));
      },
      ...options,
    }
  );
};

const useApiWithId = <
  Variables = {
    id: string;
    body?: any;
  },
  Response = any,
  Error = any
>(
  url: string,
  method: Method,
  options: UseMutationOptions<AxiosResponse<Response>, Error, Variables> = {}
) =>
  useMutation<AxiosResponse<Response>, Error, Variables>(
    ({ id, body }: any) => {
      url = id ? `${url}/${id}` : url;
      const response = api({ url, method, data: pickBy(body, Boolean) });
      return response;
    },
    // @ts-ignore
    { ...options }
  );

export { useApi, useApiMutation, useApiWithId };
